<template>
  <div class="tw-h-full tw-w-full tw-shadow tw-p-0 tw-pb-1 tw-m-0 tw-bg-gray-100" style="height: 50%; min-height: 200px; background-color: whitesmoke;">
    
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0">
      <b-tabs card fill>
        <b-tab title="Baseline">
          <b-card-text>
            <h5 class="tw-font-bolder tw-mb-0 text-center">
              SUBJECTS
            </h5>
            <p class="text-secondary tw-text-xs text-center">
              Closed During Baseline
            </p>
            <br />
            <b-row>
              <b-col>
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ baseline_core }} / {{ baseline_core_total }}</h1>
                <p class="text-secondary tw-text-xs text-center" v-if="STUDY == 'kenya'">
                  CORE
                </p>

              </b-col>
              <b-col v-if="STUDY == 'kenya'">
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ baseline_buffer }} / {{ baseline_buffer_total }}</h1>
                <p class="text-secondary tw-text-xs text-center">
                  BUFFER
                </p>
              </b-col>
            </b-row>
            
          </b-card-text>
        </b-tab>

        <b-tab title="Intervention" v-if="STUDY == 'mali'">
          <b-card-text>
           <h5 class="tw-font-bolder tw-mb-0 text-center">
              SUBJECTS
            </h5>
            <p class="text-secondary tw-text-xs text-center">
              Closed During Intervention
            </p>
            <br />
            <b-row>
              <b-col>
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ cohort_1_core }} / {{ cohort_1_core_total }}</h1>
                <p class="text-secondary tw-text-xs text-center" v-if="STUDY == 'kenya'">
                  CORE
                </p>

              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab title="Cohort 1" v-if="STUDY == 'kenya'">
          <b-card-text>
           <h5 class="tw-font-bolder tw-mb-0 text-center">
              SUBJECTS
            </h5>
            <p class="text-secondary tw-text-xs text-center">
              Closed During Cohort 1
            </p>
            <br />
            <b-row>
              <b-col>
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ cohort_1_core }} / {{ cohort_1_core_total }}</h1>
                <p class="text-secondary tw-text-xs text-center">
                  CORE
                </p>

              </b-col>
              <b-col>
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ cohort_1_buffer }} / {{ cohort_1_buffer_total }}</h1>
                <p class="text-secondary tw-text-xs text-center">
                  BUFFER
                </p>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab title="Cohort 2" v-if="STUDY == 'kenya'" active>
          <b-card-text>
           <h5 class="tw-font-bolder tw-mb-0 text-center">
              SUBJECTS
            </h5>
            <p class="text-secondary tw-text-xs text-center">
              Closed During Cohort 2
            </p>
            <br />
            <b-row>
              <b-col>
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ cohort_2_core }} / {{ cohort_2_core_total }}</h1>
                <p class="text-secondary tw-text-xs text-center">
                  CORE
                </p>

              </b-col>
              <b-col>
                <h1 class="tw-text-5xl tw-font-bolder text-center tw-mb-0">{{ cohort_2_buffer }} / {{ cohort_2_buffer_total }}</h1>
                <p class="text-secondary tw-text-xs text-center">
                  BUFFER
                </p>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
      </b-tabs>
      
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

export default {
  mixins: [],
  computed: {},
  data() {
    return {
      baseline_core: 0,
      baseline_core_total: 0,
      baseline_buffer: 0,
      baseline_buffer_total: 0,

      cohort_1_core: 0,
      cohort_1_core_total: 0,
      cohort_1_buffer: 0,
      cohort_1_buffer_total: 0,

      cohort_2_core: 0,
      cohort_2_core_total: 0,
      cohort_2_buffer: 0,
      cohort_2_buffer_total: 0
    };
  },
  created: function() {},
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;
      HTTP.get('/kenya/metrics/subjects-closed').then((response) => {
        if(that.STUDY == 'kenya'){
          that.baseline_core = response.data.baseline.core;
          that.baseline_core_total = response.data.baseline.core_total;
          that.baseline_buffer = response.data.baseline.buffer;
          that.baseline_buffer_total = response.data.baseline.buffer_total;

          that.cohort_1_core = response.data.cohort_1.core;
          that.cohort_1_buffer = response.data.cohort_1.buffer;
          that.cohort_1_core_total = response.data.cohort_1.core_total;
          that.cohort_1_buffer_total = response.data.cohort_1.buffer_total;

          that.cohort_2_core = response.data.cohort_2.core;
          that.cohort_2_buffer = response.data.cohort_2.buffer;
          that.cohort_2_core_total = response.data.cohort_2.core_total;
          that.cohort_2_buffer_total = response.data.cohort_2.buffer_total;
        }
        if(that.STUDY == 'mali'){
          that.baseline_core = response.data.baseline.core;
          that.baseline_core_total = response.data.baseline.core_total;
          
          that.cohort_1_core = response.data.intervention.core;
          that.cohort_1_core_total = response.data.intervention.core_total;
        }
          
      });
    }
  }
};
</script>

<style>
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 0.5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: 0.35rem 0.5rem;
}
</style>
